// modules/Splide.js
import Splide from '@splidejs/splide';

class SplideSlider {
  constructor() {
    // ensure DOM is ready before querying (optional but safe)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.events());
    } else {
      this.events();
    }
  }

  events() {
    const sliders = document.querySelectorAll('.splide');
    if (!sliders.length) return;

    for (let i = 0; i < sliders.length; i++) {
      // Skip if already initialized
      if (sliders[i].classList.contains('is-initialized')) continue;

      const slideCount = sliders[i].querySelectorAll('.splide__slide').length;

      new Splide(sliders[i], {
        type: 'loop',
        perPage: sliders[i].dataset.perPage || 1,
        breakpoints: {
          1024: { perPage: sliders[i].dataset.perPageMedium || 1 },
          640:  { perPage: sliders[i].dataset.perPageSmall || 1 },
        },
        gap: '1rem',
        arrows: true,
        pagination: slideCount > 1 && !(sliders[i].dataset.pagination === 'no'),
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoHeight: true,
        arrowPath: 'M22.1667 28.7917 ... 29.2917Z',
      }).mount();
    }
  }
}

export default new SplideSlider();